/**
  * 定制分类 接口的统一出口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const custommadecate = {
  // 列表
  list (params) {
    return axios.get(api + 'custommadecate/list', { params: params })
  },
  // 添加
  create (params) {
    return axios.post(api + 'custommadecate/create', qs.stringify(params))
  },
  // 修改
  edit (params) {
    return axios.post(api + 'custommadecate/edit', qs.stringify(params))
  },
  // 修改状态
  status (params) {
    return axios.post(api + 'custommadecate/status', qs.stringify(params))
  },
  // 删除
  remove (params) {
    return axios.post(api + 'custommadecate/remove', qs.stringify(params))
  },
  // 详情
  detail (params) {
    return axios.post(api + 'custommadecate/detail', qs.stringify(params))
  }

}

// 导出接口
export default custommadecate
